<template>
  <ul class="flex-row items-center">
    <WebSite></WebSite>
    <div class="w-1px h-16px bg-[--gray-200] mx-32px"></div>
    <!-- 授权管理员不显示充值入口 -->
    <NavDeposit v-if="userStore.isLogin && kycStatus && userTypeSupport && !userStore?.isAuthorizedAdmin" />
    <template v-for="(item, index) in filterNavList" :key="index">
      <li :class="[item.class]" class="text-1 relative mr24">
        <!-- :class="{'active': isActivePath(item)}" -->
        <a v-if="item.name === 'academy'" class="nav-item text-sm-m" target="_blank" :href="item.link">
          {{ item.text }}
        </a>
        <!-- 经济业务子菜单 一键买卖 + 大宗交易, 入口权限判定 全量用户所有的用户包括未登陆都能看到入口 -->
        <!-- <NavHashBrokerage
          v-else-if="item.name === 'hashBrokerage' && hasViewRfqPermission"
        /> -->
        <!-- 添加id标志位 为划转引导第四步获取 spot nav 距离视口左侧的距离  -->
        <template v-if="item.name === 'financial'">
          <router-link
            v-if="(userStore.stoInfo.grayPeriod && hasStoAccount) || userStore.stoInfo.grayPeriod === false" :id="item.id ?? ''" :to="item.link"
            class="nav-item text-sm-m flex-row items-center" @click="eventTrack({ name: item.eventTrackName })">
            {{ item.text }}
          </router-link>
        </template>
        <!-- <router-link v-else-if="item.name === 'financial' && hasStoAccount" :id="item.id ?? ''" :to="item.link" class="nav-item text-sm-m flex-row items-center" @click="eventTrack({ name: item.eventTrackName })">
          {{ item.text }}
        </router-link> -->
        <router-link
          v-else :id="item.id ?? ''" :to="item.link" class="nav-item text-sm-m flex-row items-center"
          @click="eventTrack({ name: item.eventTrackName })">
          {{ item.text }}
        </router-link>
      </li>
    </template>
    <MoreBusiness v-if="showMore" :list="moreList" />
    <!-- <li
      :class="[currentLang]" class="community text-1 text-md-m mr24" @mouseenter="showCommunity('show')"
      @mouseleave="showCommunity('')"
    >
      <span class="mainTitle">{{ t("社区") }}</span>
      <img src="@/assets/img/header/gift.png" class="ml4" alt="">
      <ul :class="[communityShow]" class="subLinkFrame">
        <li class="twitter" @click="goCommunity('twitter')">
          {{ t("Twitter") }}
        </li>
        <li class="telegram" @click="goCommunity('telegram')">
          <div>
            {{ t("Telegram") }}
          </div>
          <img :src="imgSrc" class="ml4" alt="">
        </li>
      </ul>
    </li> -->
    <!-- <li class="text-1 mr24">
      <router-link to="/campaigns/api-rewards" class="nav-item text-md-m" @click="gaTag('c_homeguide_apireward')">
        {{ $t('API奖励') }}
      </router-link>
    </li> -->
  </ul>
</template>

<script setup lang="ts">
import eventTrack from '@/utils/eventTracking';
import { useUserStore } from '@/store/User';
import { useKycInfoStore } from '@/store/kyc';
import { i18n } from '@/lang/i18n';
import srcSc from '@/assets/img/header/tag-sc.svg';
import srcTc from '@/assets/img/header/tag-tc.svg';
import srcEn from '@/assets/img/header/tag-en.svg';
import NavDeposit from './NavDeposit.vue';
import WebSite from './WebSite.vue';
import NavHashBrokerage from './NavHashBrokerage.vue';
import MoreBusiness from './MoreBusiness.vue';
import { assetApi } from '@/config/api';

const { t } = useI18n();
const route = useRoute();
const userStore = useUserStore();
const kyc = useKycInfoStore();
const hdState = ref(null);
defineProps({
  theme: {
    type: String,
    default: ''
  }
});
const communityShow = ref(false);
const showCommunity = (status: any) => {
  communityShow.value = status;
};
const currentLang = ref(localStorage.getItem('lang') || 'zh-CN');
const hasOptAccount = computed(() => {
  return userStore.isOPTAccount && userStore?.userinfo?.tmpRfq === 1;
});
const hasStoAccount = computed(() => {
  return userStore.userinfo?.tmpSto === 1;
});
const navList: any = computed(() => {
  return [
    // { link: '/markets', text: t('市场'), gaTag: 'web_maket_click' }, // hide markets 0717
    { link: '/convert', text: t('rfq.title'), eventTrackName: 'web_click_home_Convert' },
    { link: '/spot', text: t('现货交易-title'), matched: ['/spot', '/spot/:symbolPath'], eventTrackName: 'web_click_home_trade' },
    // HKEX-9084 修改经纪业务为大宗交易
    { name: 'hashBrokerage', link: '/trade/otc', text: t('header_block_trade'), eventTrackName: 'web_click_home_brokerage' },
    // HKEX-11088 新增货币兑换入口
    { link: '/currency-converter', text: t('header_fiat_exchange'), eventTrackName: 'web_click_home_fxexchange' },
    { link: '/earn', name: 'financial', text: t('理财'), eventTrackName: 'web_click_home_financial' },
    { link: '/pi-institutional', text: t('header_pi_institution'), eventTrackName: '', more: true },
    { link: '/pro-trading', text: t('header_institution'), eventTrackName: '', more: true },
    // { link: urlMap[i18n.global.locale.value], name: 'academy', text: t('学院'), gaTag: 'web_academy_click' },
    { link: '/hsk', text: t('HSK'), eventTrackName: 'web_click_home_hsk', more: true }
    // { link: '/referral', text: t('invite邀请好友'), eventTrackName: 'web_click_home_referral', more: true }
  ];
});
// 过滤导航菜单
const filterNavList = computed(() => {
  if (!showMore.value) {
    return navList.value;
  }

  return navList.value.filter((item: any) => {
    return !item.more;
  });
});
const moreList = computed(() => {
  return navList.value.filter((item: any) => item.more);
});

const injectTheme = inject('theme');

const hasViewRfqPermission = computed(() => {
  // 未登录两个导航栏都展示 11821 PI用户全量放开
  // HKEX-11450 非灰度用户暂时不展示
  return !userStore.isLogin || userStore?.userinfo?.tmpRfq === 1;
});

// 授权交易员 和 切换子账户状态 没有钱包 隐藏充值入口
const userTypeSupport = computed(() => {
  if (userStore?.userinfo?.userType == 6) {
    return false;
  } else if (userStore.currentSubAccountId) {
    return false;
  }

  return true;
});

// kyc状态判断
const kycStatus = computed(() => {
  if (kyc?.kycInfo?.totalAuditStatus == 3) {
    // 已kyclAuditStat
    return true;
  } else {
    // 未kyc
    return false;
  }
});

const routeTheme = computed(() => {
  const routeProps: any = route.meta.props;
  return routeProps?.header?.theme;
});

const imgSrc = computed(() => {
  let src = '';
  if (currentLang.value === 'zh-CN') {
    src = srcSc;
  } else if (currentLang.value === 'zh-TW') {
    src = srcTc;
  } else {
    src = srcEn;
  }
  return src;
});

const goCommunity = (type: any) => {
  let url;
  let lang = localStorage.getItem('lang') || 'zh-CN';
  if (type == 'telegram') {
    if (lang == 'en-US') {
      url = 'https://t.me/hellohashkey/12129';
      eventTrack({ name: 'web_click_home_telegram' });
    } else {
      url = 'https://t.me/hellohashkey/1380';
      eventTrack({ name: 'web_click_home_telegram' });
    }
  } else if (type == 'twitter') {
    url = 'https://twitter.com/HashKeyExchange';
    eventTrack({ name: 'web_click_home_twitter' });
  }
  window.open(url, '_blank');
};
/**
 * 导航高亮
 *
 * @param item 导航项
 */
// const isActivePath = (item: any) => {
//   const path = getOriginPath(route.path);

//   if (item.matched) {
//     const matchedPath = route.matched[0]?.path;
//     return item.matched.includes(getOriginPath(matchedPath));
//   }

//   return item.link === path;
// };

const showMore = ref(false);

const onResize = () => {
  showMore.value = window.innerWidth < 1360;
};

onMounted(() => {
  /* AG: 2023-10-29 15:21:30 */
  // Only fetch STO info if it hasn't been loaded previously
  if (!userStore.stoInfo.loaded) {
    userStore.getStoInfo();
  }
  /* AG: 2023-10-29 15:21:30 */
  onResize();
  window.addEventListener('resize', onResize);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize);
});

</script>

<style lang="scss" scoped>
.nav-item {
  cursor: pointer;
  white-space: nowrap;
  color: var(--gray-700);

  &:hover,
  &.active {
    color: var(--primary-500);
  }
}

.text-1 {
  word-break: keep-all;
}

.icon-nofee {
  font-size: 11px;
  line-height: 16px;
  font-weight: 500;
  text-align: center;
  margin-left: 4px;
  width: 41px;
  height: 16px;
  color: var(--base-white);
  background: url(@/assets/img/hk-header/icon-nofee.svg) center/cover no-repeat;
}

.dark {
  .nav-item {
    color: var(--gray-25);

    &:hover,
    &.active {
      color: var(--primary-500);
    }
  }
}

.community {
  position: relative;
  // width: 160px;
  height: 56px;
  cursor: pointer;
  display: flex;
  align-items: center;

  // &.zh-CN {
  //   background: url(@/assets/img/header/tag-sc.svg) no-repeat 70px 19px;
  // }

  // &.zh-TW {
  //   background: url(@/assets/img/header/tag-tc.svg) no-repeat 70px 19px;
  // }

  // &.en-US {
  //   // width: 210px;
  //   background: url(@/assets/img/header/tag-en.svg) no-repeat 122px 19px;
  // }

  .mainTitle {
    display: inline-block;
    height: 56px;
    line-height: 56px !important;
    color: var(--gray-600);
    transition: 0.3s all ease-in-out;

    &:hover,
    &.active {
      color: var(--gray-800);
    }
  }

  .subLinkFrame {
    display: none;
    position: absolute;
    left: 0;
    top: 56px;
    width: 248px;
    height: 120px;
    background: var(--bg-wrapper);
    border-radius: 12px;
    padding: 8px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);

    &.show {
      display: inline-block;
    }

    li {
      font-size: 14px;
      height: 52px;
      line-height: 52px;
      color: #3f3f46;
      border-radius: 8px;
      padding-left: 38px;

      &:hover {
        cursor: pointer;
      }

      &.telegram {
        display: flex;
        align-items: center;
        background: url(@/assets/img/header/icon-light-telegram.svg) no-repeat 10px 16px;

        &:hover {
          background-color: #fafafa;
        }
      }

      &.twitter {
        background: url(@/assets/img/header/icon-light-twitter.svg) no-repeat 10px 16px;

        &:hover {
          background-color: #fafafa;
        }
      }
    }
  }
}

.dark {
  .vline {
    background: var(--gray-700);
  }

  .community {
    position: relative;
    // width: 160px;
    height: 56px;
    cursor: pointer;

    // &.zh-CN {
    //   background: url(@/assets/img/header/tag-sc.svg) no-repeat 70px 19px;
    // }

    // &.zh-TW {
    //   background: url(@/assets/img/header/tag-tc.svg) no-repeat 70px 19px;
    // }

    // &.en-US {
    //   width: 210px;
    //   background: url(@/assets/img/header/tag-en.svg) no-repeat 122px 19px;
    // }

    .mainTitle {
      display: inline-block;
      height: 56px;
      line-height: 56px !important;
      color: var(--gray-200);

      &:hover,
      &.active {
        color: var(--gray-400);
      }
    }

    .subLinkFrame {
      display: none;
      position: absolute;
      left: 0;
      top: 56px;
      width: 248px;
      height: 120px;
      background: #26272b;
      border-radius: 12px;
      padding: 8px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);

      &.show {
        display: inline-block;
      }

      li {
        font-size: 14px;
        height: 52px;
        line-height: 52px;
        color: #f4f4f5;
        border-radius: 8px;
        padding-left: 38px;

        &:hover {
          cursor: pointer;
        }

        &.telegram {
          background: url(@/assets/img/header/icon-dark-telegram.svg) no-repeat 10px 16px;

          &:hover {
            background-color: #2f3033;
          }
        }

        &.twitter {
          background: url(@/assets/img/header/icon-dark-twitter.svg) no-repeat 10px 16px;

          &:hover {
            background-color: #2f3033;
          }
        }
      }
    }
  }
}
</style>
